<script lang="ts">import { scale } from 'svelte/transition';
import { backOut } from 'svelte/easing';
import { COUNT_TRANSITION_DURATION } from '../../../../../js-v2/constants';
const { count = 0 } = $props();
// Fancy "bubble" scale transition intro
const TRANSITION_IN = { duration: COUNT_TRANSITION_DURATION, easing: backOut };
</script>

<span class="Count" aria-hidden="true" in:scale={TRANSITION_IN}>{count}</span>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Count {
  --letter-spacing: var(--text-variant-50-letter-spacing);
  --line-height: var(--text-variant-50-line-height);
  --font-size: var(--text-variant-50-font-size);
  --font-weight: var(--text-variant-50-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-50-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  box-sizing: border-box;
  z-index: 1;
  display: inline-flex;
  place-content: center center;
  align-items: center;
  height: 20px;
  min-width: 20px;
  padding: 0px 4px;
  margin: -10px 0px 0px -8px;
  color: var(--color-background, var(--color-neutral-000, #000000));
  background-color: var(--color-text, var(--color-neutral-000, #000000));
  border-radius: 999em;
  letter-spacing: normal;
  text-align: center;
}</style>
